import React, { useEffect, useState } from 'react'
import { Button, Col, Divider, Drawer, Radio, Row, Typography } from 'antd'
import PersonalizacionTicketPreview from './personalizacionTicketPreview'

const { Title } = Typography

function PersonalizacionTicketDrawer(props) {
  const [ticketPrintWidth, setTicketPrintWidth] = useState('3')

  useEffect(() => {
    if (props.visible && props.editData) {
      setTicketPrintWidth(props.editData.ticket_print_width || '3')
    }
  }, [props.visible, props.editData])

  const onSaveButton = () => {
    props.saveButton(props.editData.id, {
      ticket_print_width: ticketPrintWidth,
    })
  }

  return (
    <Drawer placement="right" closable={false} onClose={props.closable} visible={props.visible} width={680}>
      <Title>{`Ancho de impresión — ${props.editData?.name || ''}`}</Title>
      <div style={{ color: 'rgba(0, 0, 0, 0.45)', marginBottom: 12 }}>
        El logo y la leyenda se configuran por empresa, en la pestaña "Logo y leyenda" — todas las tiendas de{' '}
        {props.editData?.company_name || 'la empresa'} los comparten. Acá solo se elige el ancho de papel de la impresora de esta tienda.
      </div>
      <Divider className={'divider-custom-margins-users'} />
      <Row gutter={16} className={'section-space-field'}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <div className={'title-space-field'}>Ancho de impresión*</div>
          <div style={{ color: 'rgba(0, 0, 0, 0.45)', marginBottom: 8 }}>Según la impresora térmica de esta tienda. El contenido que exige SAT no cambia, solo cómo se acomoda en el papel.</div>
          <Radio.Group value={ticketPrintWidth} onChange={value => setTicketPrintWidth(value.target.value)}>
            <Radio.Button value="2">2 pulgadas</Radio.Button>
            <Radio.Button value="3">3 pulgadas</Radio.Button>
          </Radio.Group>
        </Col>
      </Row>
      <Divider className={'divider-custom-margins-users'} />
      <div className={'title-space-field'}>Vista previa</div>
      <div style={{ color: 'rgba(0, 0, 0, 0.45)', marginBottom: 12 }}>Con el logo y la leyenda ya configurados de la empresa.</div>
      <PersonalizacionTicketPreview
        logo={props.editData?.ticket_logo}
        printWidth={ticketPrintWidth}
        legend={props.editData?.ticket_legend}
        subjectQuarterlyIsr={props.editData?.subject_quarterly_isr}
        ivaRetentionAgent={props.editData?.iva_retention_agent}
      />
      <Divider className={'divider-custom-margins-users'} />
      <Row gutter={16}>
        <Col xs={24} sm={24} md={24} lg={24}>
          <div className="text-right">
            <Button type="link" className="cancel-button" onClick={() => props.cancelButton()}>
              Cancelar
            </Button>
            <Button htmlType="submit" className="title-tendero new-button" onClick={onSaveButton}>
              Guardar
            </Button>
          </div>
        </Col>
      </Row>
    </Drawer>
  )
}

export default PersonalizacionTicketDrawer
